import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import AdvancedSearch from '../AdvancedSearch'
import { FilterTagWrapper, FilterTagsWrapper, FilterExportWrapper, GlobalAdvancedFilterWrapper, FilterProfilesWrapper } from './styles'
import { Text } from '../../constants/TextConstants'
import AppliedFiltersTags from '../AdvancedSearch/AppliedFiltersTags'
import GlobalSearch from '../GlobalSearch'
import { AdvancedSearchButton } from '../AdvancedSearch/styles'
import { BqIcon, BqTag } from '@beeq/react'
import { useBoolean } from '../../hooks/useBoolean'

export default function FilterExport ({
  exportBtnComponent,
  advancedSearchOptions,
  advancedSearchFilterData,
  handleSearch,
  resetAdvancedSearchFilterData
}) {
  const [advancedSearchVisible, { on: openAdvancedSearch, off: closeAdvancedSearch }] = useBoolean()
  const { globalSearch, ...advancedSearchFilter } = advancedSearchFilterData

  const filtersCount = useMemo(() => {
    const { completion, lastUpdateFrom, lastUpdateTo, status, ...rest } = advancedSearchFilter

    return Object.values(rest).reduce((acc, value) => {
      if (Array.isArray(value) && value.length) {
        return acc + 1
      } else if (typeof value === 'string' && value !== '') {
        return acc + 1
      }
      return acc
    }, 0)
  }, [advancedSearchFilter])

  return (
    <FilterProfilesWrapper>
      <FilterExportWrapper>
        <GlobalAdvancedFilterWrapper>
          <GlobalSearch
            handleSearch={(globalSearchQuery) => handleSearch({ globalSearch: globalSearchQuery })}
            globalSearchParam={globalSearch} />
          <AdvancedSearchButton
            data-testid='advanced-search-filter-profile-button'
            variant='ghost'
            border='s'
            onBqClick={openAdvancedSearch}
          >
            <BqIcon name='funnel' slot='prefix' />
            {Text.AdvancedSearchButton}
            <BqTag clickable size='small' slot='suffix' data-testid='advanced-search-filter-selected-filters'>
              {filtersCount}
            </BqTag>
          </AdvancedSearchButton>
          <AdvancedSearch
            advancedSearchVisible={advancedSearchVisible}
            closeAdvancedSearch={closeAdvancedSearch}
            advancedSearchOptions={advancedSearchOptions}
            handleAdvancedSearch={(filters) => handleSearch(filters)}
            resetAdvancedSearchFilterData = {resetAdvancedSearchFilterData}
            advancedSearchFilter={advancedSearchFilter}
          />
        </GlobalAdvancedFilterWrapper>
        <div style={{ alignItems: 'flex-end' }}>
          {exportBtnComponent}
        </div>
    </FilterExportWrapper>
    {!advancedSearchVisible &&
      <FilterTagsWrapper>
        <>
          {filtersCount
            ? <span style={{ paddingRight: '8px' }}>{Text.AdvancedSearchAppliedFilters}</span>
            : <></>
          }
          <FilterTagWrapper>
            <AppliedFiltersTags
              filterData={advancedSearchFilter}
              handleAdvancedSearch={(filters) => handleSearch(filters)}
            />
          </FilterTagWrapper>
        </>
      </FilterTagsWrapper>
    }
    </FilterProfilesWrapper>
  )
}

FilterExport.propTypes = {
  exportBtnComponent: PropTypes.node,
  advancedSearchOptions: PropTypes.object,
  advancedSearchFilterData: PropTypes.object,
  handleSearch: PropTypes.func.isRequired,
  resetAdvancedSearchFilterData: PropTypes.func.isRequired
}
